import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { fetchFamilyFestCompanyAttendeesAsync } from './familyFestCompanyAttendeesThunk';
const initialState = {
    status: APIStatus.IDLE,
    companies: []
};
const familyFestCompanyAttendeesSlice = createSlice({
    name: 'familyFestCompanyAttendees',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFamilyFestCompanyAttendeesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(fetchFamilyFestCompanyAttendeesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.companies = action.payload;
        })
            .addCase(fetchFamilyFestCompanyAttendeesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default familyFestCompanyAttendeesSlice.reducer;
